/**
 * Fixed bottom banner that marks a labelled, non-production build (for
 * example "DEV") so nobody mistakes the test site for the live one. Renders
 * nothing without a label, which is the case for the live (studio) build.
 */
export function EnvironmentBanner({ label }: { label?: string }): JSX.Element | null {
  if (!label || label.trim().length === 0) {
    return null;
  }
  return (
    <div className="env-banner" role="note">
      {label} — test site. Bookings made here don't reach the live site.
    </div>
  );
}
